import { FC, useContext } from 'react';

import { Label, Modal, Paragraph, Separator } from '@smartshell/ui-kit';

import { FeatureHOC } from 'features';
import { LocalizationContext } from 'localization';
import { SettingsContext } from 'settings';
import { sanitizeHTML } from 'utils';

import { Rate } from '../Rate';
import { fixTextFormatters, formatDate } from '../utils';
import { IRateProps } from './interfaces';
import s from './ReviewModal.module.scss';

export const ReviewModal: FC<IRateProps> = ({
  data: {
    host_group_name,
    host_alias,
    author,
    request_contact,
    request_contact_info,
    created_at,
    grade,
    text,
    tips,
    worker_name,
  },
  close,
}) => {
  const { t } = useContext(LocalizationContext);
  const {
    state: {
      settings: {
        currency: { sign },
      },
    },
  } = useContext(SettingsContext);

  return (
    <Modal className={s.container} onClose={close}>
      <div className={s.block}>
        {author?.nickname ?? t('client.guest')}
        <div className={s.additional}>
          <Rate rate={grade} />
          <div className={s.hostData}>
            <span>{host_alias}</span>
            <span>{host_group_name}</span>
          </div>
        </div>
      </div>
      <div className={s.block}>
        <div
          className={s.date}
          dangerouslySetInnerHTML={{
            __html: formatDate(sanitizeHTML(created_at)),
          }}
        />
        {text && <div className={s.text}>{fixTextFormatters(text)}</div>}
        {request_contact_info && (
          <div className={s.contact_block}>
            <Separator />
            <div className={s.contact}>
              <span className={s.contact_title}>
                {t('review.contact.info')}
              </span>
              <span className={s.contact_info}>{request_contact_info}</span>
            </div>
          </div>
        )}
      </div>
      {(request_contact || Boolean(tips)) && (
        <div className={s.footer}>
          {request_contact && (
            <Label
              iconName="SpeakerIcon"
              size="s"
              text={t('review.contact.tried')}
            />
          )}
          <FeatureHOC alias="tips">
            {Boolean(tips) && (
              <div className={s.tips}>
                <Paragraph size="s" color="secondary">
                  {worker_name}
                </Paragraph>
                <Label
                  iconName="HandCoinIcon"
                  size="s"
                  color="green"
                  text={`${tips || 0} ${sign}`}
                />
              </div>
            )}
          </FeatureHOC>
        </div>
      )}
    </Modal>
  );
};
